import {
  /* PRICE LIST */
  GET_PRICES_DATA,
  GET_PRICES_DATA_SUCCESS,
  GET_PRICES_DATA_FAIL,
  ADD_PRICE_PRODUCT,
  ADD_PRICE_PRODUCT_SUCCESS,
  ADD_PRICE_PRODUCT_FAIL,
  UPDATE_PRICE_PRODUCT,
  UPDATE_PRICE_PRODUCT_SUCCESS,
  UPDATE_PRICE_PRODUCT_FAIL,
  DELETE_PRICE_PRODUCT,
  DELETE_PRICE_PRODUCT_SUCCESS,
  DELETE_PRICE_PRODUCT_FAIL,
  UPDATE_RESP_REGION,
  UPDATE_RESP_REGION_SUCCESS,
  UPDATE_RESP_REGION_FAIL,
  CLEAR_FONT,
  CLEAR_FONT_SUCCESS,
  GET_FONT,
  GET_FONT_SUCCESS,
  GET_FONT_FAIL,

  /* PRICE INFO */
  GET_INFO_DATA,
  GET_INFO_DATA_SUCCESS,
  GET_INFO_DATA_FAIL,
  ADD_INFO_DATA,
  ADD_INFO_DATA_SUCCESS,
  ADD_INFO_DATA_FAIL,
  UPDATE_INFO_DATA,
  UPDATE_INFO_DATA_SUCCESS,
  UPDATE_INFO_DATA_FAIL,
  DELETE_INFO_DATA,
  DELETE_INFO_DATA_SUCCESS,
  DELETE_INFO_DATA_FAIL,

  // GET_CAT_PRODUCTS_DATA,
  // GET_CAT_PRODUCTS_DATA_SUCCESS,
  // GET_CAT_PRODUCTS_DATA_FAIL,
  // GET_ACCESS_DATA,
  // GET_ACCESS_DATA_SUCCESS,
  // GET_ACCESS_DATA_FAIL,
  // GET_PRODUCTS_DATA,
  // GET_PRODUCTS_DATA_SUCCESS,
  // GET_PRODUCTS_DATA_FAIL,
  // GET_REG_PRODUCTS_DATA,
  // GET_REG_PRODUCTS_DATA_SUCCESS,
  // GET_REG_PRODUCTS_DATA_FAIL,


  // GET_REGION_INFO,
  // GET_REGION_INFO_SUCCESS,
  // GET_REGION_INFO_FAIL,



  // ADD_DATA_REGION,


  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

// GET CATEGORIES DATA
export const getPricesData = () => ({
  type: GET_PRICES_DATA
});
export const getPricesDataSuccess = (data) => ({
  type: GET_PRICES_DATA_SUCCESS,
  payload: data
});
export const getPricesDataFail = error => ({
  type: GET_PRICES_DATA_FAIL,
  payload: error,
});
// ADD NEW PRODUCT
export const addPriceProduct = (product) => ({
  type: ADD_PRICE_PRODUCT,
  payload: product
});
export const addPriceProductSuccess = product => ({
  type: ADD_PRICE_PRODUCT_SUCCESS,
  payload: product,
});
export const addPriceProductFail = error => ({
  type: ADD_PRICE_PRODUCT_FAIL,
  payload: error,
});
// UPDATE PRODUCT
export const updatePriceProduct = product => ({
  type: UPDATE_PRICE_PRODUCT,
  payload: product,
});
export const updatePriceProductSuccess = product => ({
  type: UPDATE_PRICE_PRODUCT_SUCCESS,
  payload: product,
});
export const updatePriceProductFail = error => ({
  type: UPDATE_PRICE_PRODUCT_FAIL,
  payload: error,
});
// DELETE PRODUCT
export const deletePriceProduct = (product) => ({
  type: DELETE_PRICE_PRODUCT,
  payload: product
});
export const deletePriceProductSuccess = product => ({
  type: DELETE_PRICE_PRODUCT_SUCCESS,
  payload: product,
});
export const deletePriceProductFail = error => ({
  type: DELETE_PRICE_PRODUCT_FAIL,
  payload: error,
});
// UPDATE RESPONSIBLE FOR REGION
export const updateRespRegion = (person) => ({
  type: UPDATE_RESP_REGION,
  payload: person,
});
export const updateRespRegionSuccess = person => ({
  type: UPDATE_RESP_REGION_SUCCESS,
  payload: person
});
export const updateRespRegionFail = error => ({
  type: UPDATE_RESP_REGION_FAIL,
  payload: error,
});
// CLEAR FONT DATA
export const clearFont = () => ({
  type: CLEAR_FONT
});
export const clearFontSuccess = (data) => ({
  type: CLEAR_FONT_SUCCESS,
  payload: data
});
// GET FONT FOR DIFFERENT LANGUAGE
export const getFont = (product) => ({
  type: GET_FONT,
  payload: product,
});
export const getFontSuccess = (product) => ({
  type: GET_FONT_SUCCESS,
  payload: product
});
export const getFontFail = error => ({
  type: GET_FONT_FAIL,
  payload: error,
});


// GET INFO DATA
export const getInfoData = () => ({
  type: GET_INFO_DATA
});
export const getInfoDataSuccess = (data) => ({
  type: GET_INFO_DATA_SUCCESS,
  payload: data
});
export const getInfoDataFail = error => ({
  type: GET_INFO_DATA_FAIL,
  payload: error,
});
// ADD NEW INFO
export const addInfoData = (data) => ({
  type: ADD_INFO_DATA,
  payload: data
});
export const addInfoDataSuccess = data => ({
  type: ADD_INFO_DATA_SUCCESS,
  payload: data,
});
export const addInfoDataFail = error => ({
  type: ADD_INFO_DATA_FAIL,
  payload: error,
});
// UPDATE INFO
export const updateInfoData = data => ({
  type: UPDATE_INFO_DATA,
  payload: data,
});
export const updateInfoDataSuccess = data => ({
  type: UPDATE_INFO_DATA_SUCCESS,
  payload: data,
});
export const updateInfoDataFail = error => ({
  type: UPDATE_INFO_DATA_FAIL,
  payload: error,
});
// DELETE INFO
export const deleteInfoData = (data) => ({
  type: DELETE_INFO_DATA,
  payload: data
});
export const deleteInfoDataSuccess = data => ({
  type: DELETE_INFO_DATA_SUCCESS,
  payload: data,
});
export const deleteInfoDataFail = error => ({
  type: DELETE_INFO_DATA_FAIL,
  payload: error,
});



// GET CATEGORY PRODUCT DATA
// export const getCatProductsData = (data) => ({
//   type: GET_CAT_PRODUCTS_DATA,
//   payload: data,
// });
// export const getCatProductsDataSuccess = (data) => ({
//   type: GET_CAT_PRODUCTS_DATA_SUCCESS,
//   payload: data
// });
// export const getCatProductsDataFail = error => ({
//   type: GET_CAT_PRODUCTS_DATA_FAIL,
//   payload: error
// });
// // GET ACCESS DATA
// export const getAccessData = () => ({
//   type: GET_ACCESS_DATA
// });
// export const getAccessDataSuccess = (data) => ({
//   type: GET_ACCESS_DATA_SUCCESS,
//   payload: data
// });
// export const getAccessDataFail = error => ({
//   type: GET_ACCESS_DATA_FAIL,
//   payload: error,
// });
// // GET DEFAULT PRODUCTS DATA
// export const getProductsData = (data) => ({
//   type: GET_PRODUCTS_DATA,
//   payload: data
// });
// export const getProductsDataSuccess = (data) => ({
//   type: GET_PRODUCTS_DATA_SUCCESS,
//   payload: data
// });
// export const getProductsDataFail = error => ({
//   type: GET_PRODUCTS_DATA_FAIL,
//   payload: error,
// });
// // GET SELECTED REGION PRODUCTS DATA
// export const getRegProductsData = (data) => ({
//   type: GET_REG_PRODUCTS_DATA,
//   payload: data
// });
// export const getRegProductsDataSuccess = data => ({
//   type: GET_REG_PRODUCTS_DATA_SUCCESS,
//   payload: data,
// })
// export const getRegProductsDataFail = error => ({
//   type: GET_REG_PRODUCTS_DATA_FAIL,
//   payload: error,
// })




// // GET REGION INFO
// export const getRegionInfo = (product) => ({
//   type: GET_REGION_INFO,
//   payload: product
// });
// export const getRegionInfoSuccess = product => ({
//   type: GET_REGION_INFO_SUCCESS,
//   payload: product,
// });
// export const getRegionInfoFail = error => ({
//   type: GET_REGION_INFO_FAIL,
//   payload: error,
// });








// export const addDataRegion = (products) => ({
//   type: ADD_DATA_REGION,
//   payload: products
// });




export const showLoading = (status) => ({
  type: SHOW_LOADING,
  payload: status
});
export const hideLoading = (status) => ({
  type: HIDE_LOADING,
  payload: status
});
